// src/utils/userUtils.js
import { jwtDecode } from "jwt-decode";

// Decode user token
// const userToken = localStorage.getItem("access_token");
// const user = userToken ? jwtDecode(userToken) : null;
// const userId = user ? user.user_id : null;
// const isAdmin = user ? user.is_staff || user.is_superuser : false;

// Get user info from local storage
export const getUserInfo = () => {
  const token = localStorage.getItem("access_token");
  if (!token) return null;

  try {
    const decoded = jwtDecode(token); // Fix the usage here as well
    return {
      id: decoded.user_id,
      isAdmin: decoded.is_staff || decoded.is_superuser,
    };
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};

// Check if the current user can edit or delete an item
export const canEditDelete = (item) => {
  const userInfo = getUserInfo();
  if (!userInfo) return false;

  return (
    userInfo.isAdmin || (userInfo.id && item.created_by?.id === userInfo.id)
  );
};
